import React from 'react';
import { Heading } from '../../components';
import { richText } from '../../util/richText';

import css from './ListingPage.module.css';
import classNames from 'classnames';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const SectionTextMaybe = props => {
  const { text, heading, showAsIngress = false } = props;
  const textClass = showAsIngress ? css.ingress : css.text;
  const content = richText(text, {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
    breakChars: '/',
  });

  return text ? (
    <section className={classNames(css.sectionText,css.aboubtMusic)}>
      {heading ? (
        <Heading as="h2" rootClassName={classNames(css.sectionHeading, css.aboutVinyle)}>
          {heading}
        </Heading>
      ) : null}
      <p className={classNames(textClass, css.aboutVinyleValue)}>{content}</p>
    </section>
  ) : null;
};

export default SectionTextMaybe;
